import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideBaasInitialized } from '@lvflanders/bar-ng';
import { _provideBaasBurgerprofielContactAction } from '@lvflanders/bar-ng-ui';

import { BarAppMenuInitHook } from './bar-app-menu-init.hook';
import { BaasContainerBurgerprofielService } from './burgerprofiel/baas-container-burgerprofiel.service';
import { BurgerprofielStartschermContactFormHook } from './burgerprofiel/burgerprofiel-startscherm-contact-form-hook';

// make sure to load bar-ui web components
import '@lvflanders/bar-ui';

export function provideBarContainer(): EnvironmentProviders {
    return makeEnvironmentProviders(_provideBarContainer());
}
function _provideBarContainer() {
    return [
        provideBaasInitialized(BarAppMenuInitHook),
        _provideBaasBurgerprofielContactAction(BurgerprofielStartschermContactFormHook),
        BaasContainerBurgerprofielService
    ];
}
